import { copy } from "@wheels-crm/shared-types";
import type { Database } from "@wheels-crm/shared-types";

type ReminderRow = Database["public"]["Tables"]["reminders"]["Row"];

function formatDdMmHhMm(iso: string): string {
  const d = new Date(iso);
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const hh = String(d.getHours()).padStart(2, "0");
  const min = String(d.getMinutes()).padStart(2, "0");
  return `${dd}.${mm} ${hh}:${min}`;
}

function formatHhMm(iso: string): string {
  const d = new Date(iso);
  return `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
}

/** Picks the soonest not-done reminder, which is what the table row badge shows. */
export function pickActiveReminder(reminders: ReminderRow[]): ReminderRow | null {
  const active = reminders.filter((r) => !r.is_done).sort((a, b) => a.due_at.localeCompare(b.due_at));
  return active[0] ?? null;
}

/**
 * Red "Прострочено" if overdue, amber "Сьогодні HH:MM" if due today, blue "DD.MM HH:MM"
 * otherwise (§6.3).
 */
export function ReminderBadge({ reminder }: { reminder: ReminderRow | null }) {
  if (!reminder) return null;

  const due = new Date(reminder.due_at);
  const now = new Date();
  const isOverdue = due.getTime() < now.getTime();
  const isToday = due.toDateString() === now.toDateString();

  if (isOverdue) {
    return (
      <span className="reminder-badge reminder-badge-overdue">
        {copy.reminders.badgeOverdue}: {formatDdMmHhMm(reminder.due_at)}
      </span>
    );
  }
  if (isToday) {
    return (
      <span className="reminder-badge reminder-badge-today">
        {copy.reminders.badgeToday} {formatHhMm(reminder.due_at)}
      </span>
    );
  }
  return <span className="reminder-badge reminder-badge-upcoming">{formatDdMmHhMm(reminder.due_at)}</span>;
}
